import { AwardNominationSummary } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getAwardNominationSummaries: (
  fetchContext: FetchContext,
  awardId: number, 
  searchText?: string,
  accessToken?: string,
) => Promise<AwardNominationSummary[]> = (fetchContext, awardId, searchText, accessToken) => {
  const params = new URLSearchParams();
  if (searchText && searchText.length > 0) params.append('searchText', searchText);

  return fetch(`${fetchContext.baseUrl}/api/staff/awards/${awardId}/nomination-summaries${params.size > 0 ? `?${params}` : ''}`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    })
    .then((response) => responseErrorHandler<AwardNominationSummary[]>(fetchContext.errorStore, response, 'get award nomination summaries'));
};
